export const profile = {
  login: 'YuFy1314',
  name: '苏日俪格',
  bio: '一名前端攻城狮 ✌🏻',
  company: 'XiaoMi',
  location: 'Beijing, China',
  since: '2016',
  avatar: 'https://avatars.githubusercontent.com/u/24446694?v=4',
  github: 'https://github.com/YuFy1314',
  resume: 'https://yufy1314.github.io/resume/',
  archive: 'http://yufy1314.github.io/',
  tagline: 'Conceit makes one\'s progress — Pride makes one lag behind',
  intro:
    '专注 JavaScript / 前端工程化，热爱源码阅读与开源实践。这里记录技术思考，也展示 GitHub 上的项目足迹。',
  stats: {
    repos: 24,
    followers: 41,
    following: 16,
    gists: 13,
  },
};
